module.exports = __webpack_public_path__ + "img/xudawang.a705c150.jpg";